import {
    Api, ClientUpdateHandlerRegistry, ClientUpdateRequestType, InstanceIdentifier, ModelRow, StringUtil
} from "@mcleod/core";
import { ComponentFactory, DataSourceAction, DataSourceExecutionEvent, TableRow } from "@mcleod/components";
import { AutogenLayoutTemporaryLicenseRevoke } from "./autogen/AutogenLayoutTemporaryLicenseRevoke";

export class TemporaryLicenseRevoke extends AutogenLayoutTemporaryLicenseRevoke {
    override onLoad() {
        this.addBulletedNoteLabels();
    }

    private addBulletedNoteLabels() {
        const marginLeft = 12;
        const notes = ComponentFactory.createBulletedList([
            { text: "The user returns to this screen and enables the revoked licenses", marginLeft },
            { text: "The McLeodWebServer process is restarted", marginLeft }
        ]);
        this.layoutheaderTLR.addBottomTools(...notes);
    }

    sourceLicensesAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            this.tableLicenses.selectedRows = this.tableLicenses.rows;
        }
    }

    async buttonSaveOnClick() {
        try {
            this.buttonSave.busy = true;
            await this.sendRevokedModulesToServer();
            this.refreshThisClient();
        } finally {
            this.buttonSave.busy = false;
        }
    }

    private async sendRevokedModulesToServer() {
        // Send revoked license module names to the server.
        const revokedModuleNames = this.gatherRevokedModuleNames();
        const requestBody = {
            revoked_modules: revokedModuleNames,
            requesting_web_client_id: InstanceIdentifier.get()
        }
        await Api.update("common/license/revoke-user-licensed-modules", requestBody);
    }

    private gatherRevokedModuleNames(): string[] {
        // Returns an array of proper module names that the user chose to revoke (that are unchecked)
        const selectedRows = this.tableLicenses.selectedRows;
        return this.tableLicenses.allRows
            ?.filter((row: TableRow) => !selectedRows.includes(row))
            .map((row: TableRow) => (row.data as ModelRow).getString("module_name", ""))
            .filter((moduleName: string) => !StringUtil.isEmptyString(moduleName)) ?? [];
    }

    private refreshThisClient() {
        // The server will notify all of the user's other open tabs to refresh their settings.  It might take the server
        // a few seconds to locate/notify those tabs, so rather than have that process update the current tab, we'll
        // update it here so that it happens right away.
        const handler = ClientUpdateHandlerRegistry.get().getObject(ClientUpdateRequestType.TEMPORARY_LICENSE_CHANGE);
        handler?.handle();
    }
}
